import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import AssetRenamePanel from '../../components/AssetRenamePanel';

const mapStateToProps = (state: StoreState) => {
	const { assetRenamePanel } = state;
	const { isOpen, name, assetId, error } = assetRenamePanel;
	return { isOpen, name, assetId, error };
};

export default connect(mapStateToProps)(AssetRenamePanel);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/AssetRenamePanel/index.ts